import { render } from "./Lightbox.vue?vue&type=template&id=89b41f48&scoped=true"
import script from "./Lightbox.vue?vue&type=script&lang=js"
export * from "./Lightbox.vue?vue&type=script&lang=js"

import "./Lightbox.vue?vue&type=style&index=0&id=89b41f48&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b41f48"],['__file',"src/components/mdbvue/pro/Advanced/Lightbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "89b41f48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('89b41f48', __exports__)) {
    api.reload('89b41f48', __exports__)
  }
  
  module.hot.accept("./Lightbox.vue?vue&type=template&id=89b41f48&scoped=true", () => {
    api.rerender('89b41f48', render)
  })

}


export default __exports__